import { Grid, TextField } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons'
import { commentsTypes } from './const'
import { WorkListCommentCard } from './WorkListCommentCard'
import { useStyles } from './work-list-comments.styles'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import { SalesService } from 'lib/api'
import { useWorkListViewRopStore } from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import { NotFound } from 'components/NotFound'

export const WorkListComments = ({ id, globalId }) => {
  const classes = useStyles()

  const {
    actions: { setLoading }
  } = useWorkListViewRopStore()
  const [comments, setComments] = useState([])
  const [comment, setComment] = useState('')
  const [activeTab, setActiveTab] = useState('COMMENTS')

  useEffect(() => {
    getAllComments()
  }, [])

  const getAllComments = async () => {
    await SalesService.getAllComments(globalId).then(res => {
      if (res.status === 200) {
        setComments(res?.data)
      }
    })
  }
  const handleAddComment = () => {
    if (!comment?.trim()?.length) {
      return null
    }

    setLoading(true)

    const data = {
      type: activeTab,
      text: comment
    }

    SalesService.addSaleComments(id, data)
      .then(res => {
        if (res?.data) {
          setComment('')
          getAllComments()
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const filterByActiveTab = comment => {
    switch (activeTab) {
      case 'COMMENTS':
        return true
      case '@result':
        return (
          comment.type === 'CS_ISSUANCE_CAR' ||
          comment.type === 'CS_ISSUE' ||
          comment.type === 'CS_MEET_CLIENT' ||
          comment.type === 'CS_CALL_CLIENT' ||
          comment.type === '@result'
        )
      case 'MISSING':
        return comment.type === '@close:' || comment.type === 'MISSING'
      case 'FINSERVICE':
        return comment.type === 'FINSERVICE'
      default:
        return false
    }
  }

  const data = comments?.filter(filterByActiveTab)

  return (
    <Grid container>
      <Grid item container className={classes.commentsFilter}>
        <AsterToggleButtonGroup
          exclusive
          value={activeTab}
          onChange={(e, val) => {
            setActiveTab(val)
          }}
        >
          {commentsTypes.map(({ label, code }, i) => (
            <AsterToggleButton key={`comments-toggle-btn-${code}`} value={code}>
              {label}
            </AsterToggleButton>
          ))}
        </AsterToggleButtonGroup>
      </Grid>

      <Grid item container>
        {data?.length ? (
          data.map((e, i) => (
            <Grid
              item
              xs={12}
              key={`work-list-comment-card-${i}`}
              className={classes.comment}
            >
              <WorkListCommentCard comment={e} />
            </Grid>
          ))
        ) : (
          <NotFound title="Нет комментариев" />
        )}
      </Grid>
      {activeTab === 'COMMENTS' && (
        <Grid item container style={{ marginTop: 24 }}>
          <Grid item xs={12}>
            <TextField
              label="Комментарий"
              value={comment}
              multiline
              minRows={4}
              fullWidth
              style={{ backgroundColor: 'white' }}
              onChange={e => setComment(e.target.value)}
            />
          </Grid>
          <Grid
            item
            container
            justifyContent="flex-end"
            style={{ marginTop: 32 }}
            onClick={handleAddComment}
          >
            <AsterButton color="primary">Добавить комментарий</AsterButton>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}
